import Image from 'next/image';
import classNames from 'classnames';
import React from 'react';

import styles from './Loader.module.scss';

const Loader = ({ fullScreen, className }) => {
  return (
    <div
      className={classNames([
        styles.loader_wrap,
        { [styles.fullScreen]: fullScreen === true },
        className,
      ])}
      data-testid='loader'
      itemScope
      itemType='https://schema.org/ImageObject'
    >
      <Image
        src='/assets/load.png'
        alt='loader icon'
        title='Loader Icon'
        width={56}
        height={56}
        layout='fixed'
        className={styles.icon}
        loading='lazy'
      />
    </div>
  );
};

export default Loader;
